// Import packages
import React, {useEffect} from "react";
import {connect} from 'react-redux';
import {Link} from "react-router-dom";

// Import assets
import './mobileMenu.scss';

// Import components
import {getPropsFromState} from "../../redux/mapStateToProps";
import {ChangeLanguage,IsOpen} from "../../redux/actions";
import {
    CloseMenuIcon,
    FooterFacebookIcon,
    FooterInstagramIcon,
    LangArrIcon,
    TelegramIcon,
    YoutubeIcon
} from "../../assets/images";
import {Dropdown, Menu} from "antd";
import {useState} from "react";
import {generateFileMediaUrl} from "../../utils/generateMediaUrl";
import Socials from "../socials/Socials";

// Import utils



 function MobileMenu (props)  {
    const {className, staticTexts, toggleMobileMenu,languages,selectedLanguage,mobileMenuOpen,contacts} = props;
    const [closeLanguage, setCloseLanguage] = useState(false)

     useEffect(() => {
         props.IsOpen(mobileMenuOpen)
     },[])

    const menuLanguage = (
        <Menu className={`languages-dropdown`}>
            {
                languages?.length && languages?.map((item) => {
                    return selectedLanguage?.code !== item.code &&
                        <Menu.Item key={item.id}
                                   onClick={() => {
                                       props.ChangeLanguage(item)
                                   }}
                                   className={'language-dropdown-item'}>
                            <div className="selected-language">
                                <div className={'language-flag'}>
                                    <img src={generateFileMediaUrl(item?.icon?.path)} alt=""/>
                                </div>
                                <span>{item?.name}</span>
                            </div>
                        </Menu.Item>
                })
            }
        </Menu>
    );

    return <section className={`right-menu-wrapper ${className}`}>
        <div className={'right-menu-content'}>
            <div className={'left-menu'}>
                <div className={'menu-close-block'} onClick={toggleMobileMenu}>
                    <CloseMenuIcon/>
                </div>
                <div className={'menu-wrapper'}>
                    {/*<div className={'menu-title'}>*/}
                    {/*    {staticTexts?.header_item}*/}
                    {/*</div>*/}
                    <Link to={'/event'} onClick={toggleMobileMenu} className={`${mobileMenuOpen ? '' : 'overflow'}`}>{staticTexts?.header_item_events}</Link>
                    <Link to={'/video'} onClick={toggleMobileMenu} className={`${mobileMenuOpen ? '' : 'overflow'}`}>{staticTexts?.header_item_videos}</Link>
                    <Link to={'/travel'} onClick={toggleMobileMenu} className={`${mobileMenuOpen ? '' : 'overflow'}`}>{staticTexts?.header_item_traveling}</Link>
                    <Link to={'/project'} onClick={toggleMobileMenu} className={`${mobileMenuOpen ? '' : 'overflow'}`}>{staticTexts?.header_item_projects}</Link>
                    <Link to={'/about'} onClick={toggleMobileMenu} className={`${mobileMenuOpen ? '' : 'overflow'}`}>{staticTexts?.header_item_about}</Link>
                    <Link to={'/contact'} onClick={toggleMobileMenu} className={`${mobileMenuOpen ? '' : 'overflow'}`}>{staticTexts?.header_item_contact}</Link>
                </div>
            </div>
            <div className={`right-menu`}>
                {/*<div className="language-items">*/}
                {/*    <Dropdown overlay={menuLanguage}*/}
                {/*              trigger={['click']}*/}
                {/*              overlayClassName={`${closeLanguage ? "close" : ""}`}*/}
                {/*              onClick={() => toggleLanguage(setCloseLanguage(false))}*/}
                {/*              placement={'bottom'}>*/}
                {/*        <a className="ant-dropdown-link">*/}
                {/*            <div className="selected-language">*/}
                {/*                <div className={'language-flag'}>*/}
                {/*                    <img src={generateFileMediaUrl(selectedLanguage?.icon?.path)} alt=""/>*/}
                {/*                </div>*/}
                {/*                <span>{selectedLanguage?.name}</span> <LangArrIcon/>*/}
                {/*            </div>*/}
                {/*        </a>*/}
                {/*    </Dropdown>*/}
                {/*</div>*/}
                <div className={'mobile-menu-contact'}>
                    <div className={'mobile-menu-title'}>
                        {staticTexts?.header_connect}
                    </div>
                    <div className={'mobile-menu'}>
                        <Socials contacts={contacts}/>
                    </div>
                </div>
            </div>
        </div>
    </section>
}

const mapStateToProps = (state) => {
    return getPropsFromState(state, [
        'staticTexts',
        'contacts',
        'languages',
        'selectedLanguage',
    ])
};
const mapDispatchToProps = {
    ChangeLanguage,
    IsOpen
};

export default connect(mapStateToProps, mapDispatchToProps)(MobileMenu);